import { Appraisal } from "@/models/appraisal.entity";
import appraisalRequestService from "@/services/mrfiktiv/services/appraisal-request.service";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";

export class AppraisalFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.APPRAISAL;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.APPRAISAL, async () => {
      const response = await appraisalRequestService.getDocumentBySharedAccessToken(partnerId, refId, sct);
      const request = new Appraisal(response);

      // Add default first position to request
      if (!request.lineItems || !request.lineItems.length) {
        request.setDefaultLineItems();
      }

      return request;
    });
  }
}
